<template>
    <p
        v-html="messageCopy"
        class="cz2__ai-modal__disclaimer"
    />
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__disclaimer {
                text-align: center;
                font-size: 12px;
                font-family: 'Proxima Nova', sans-serif;
                color: #707070;

                a {
                    color: #707070;
                }
            }
        }
    }
</style>

<script>
    export default {
        props: {
            messageCopy: {
                type: String,
                default: '',
            },
        },
    };
</script>
